// extracted by mini-css-extract-plugin
export default {"list-item-group":"list-vertical-item-group_list-item-group__ULzfr","margin":"list-vertical-item-group_margin__g-sDn","line":"list-vertical-item-group_line__Ckr+K"};